"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TextInput = _interopRequireDefault(require("../text-input/TextInput"));

var _NumberInputContext = _interopRequireDefault(require("./NumberInputContext"));

var _templateObject;

var DxcNumberInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var label = _ref.label,
      name = _ref.name,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      helperText = _ref.helperText,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      optional = _ref.optional,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      min = _ref.min,
      max = _ref.max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      error = _ref.error,
      autocomplete = _ref.autocomplete,
      margin = _ref.margin,
      size = _ref.size,
      tabIndex = _ref.tabIndex;
  return /*#__PURE__*/_react["default"].createElement(_NumberInputContext["default"].Provider, {
    value: {
      typeNumber: "number",
      minNumber: min,
      maxNumber: max,
      stepNumber: step
    }
  }, /*#__PURE__*/_react["default"].createElement(NumberInputContainer, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: label,
    name: name,
    defaultValue: defaultValue,
    value: value,
    helperText: helperText,
    placeholder: placeholder,
    disabled: disabled,
    optional: optional,
    prefix: prefix,
    suffix: suffix,
    error: error,
    onChange: onChange,
    onBlur: onBlur,
    autocomplete: autocomplete,
    margin: margin,
    size: size,
    tabIndex: tabIndex,
    ref: ref
  })));
});

var NumberInputContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  // Chrome, Safari, Edge, Opera\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  // Firefox\n  input[type=\"number\"] {\n    -moz-appearance: textfield;\n  }\n"])));

var _default = DxcNumberInput;
exports["default"] = _default;